import { requireAdminPage } from '@/lib/admin-auth'
import { SettingsScreen } from './settings-screen'

export const dynamic = 'force-dynamic'

export default async function SettingsPage() {
  await requireAdminPage()
  return <SettingsScreen />
}
